function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export const RestoreIcon = (_0)=>{
    let { color = '#F8BF8A' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "56",
        height: "57",
        viewBox: "0 0 56 57",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M50.148 38.328H37.464C36.7214 38.328 36.0092 38.623 35.4841 39.1481C34.959 39.6732 34.664 40.3854 34.664 41.128C34.664 41.8706 34.959 42.5828 35.4841 43.1079C36.0092 43.633 36.7214 43.928 37.464 43.928H44.184C41.0954 47.1557 37.1123 49.3861 32.7465 50.3327C28.3806 51.2793 23.8314 50.8989 19.6834 49.2403C15.5354 47.5817 11.978 44.7207 9.46846 41.0249C6.95888 37.3291 5.61169 32.9673 5.6 28.5C5.6 27.7574 5.305 27.0452 4.7799 26.5201C4.2548 25.995 3.54261 25.7 2.8 25.7C2.05739 25.7 1.3452 25.995 0.820101 26.5201C0.294999 27.0452 0 27.7574 0 28.5C0.0148026 33.9678 1.63022 39.3117 4.64689 43.8721C7.66356 48.4325 11.9495 52.0098 16.9757 54.1626C22.0019 56.3154 27.5485 56.9495 32.9309 55.9866C38.3133 55.0237 43.2959 52.5059 47.264 48.744V53.7C47.264 54.4426 47.559 55.1548 48.0841 55.6799C48.6092 56.205 49.3214 56.5 50.064 56.5C50.8066 56.5 51.5188 56.205 52.0439 55.6799C52.569 55.1548 52.864 54.4426 52.864 53.7V41.1C52.8571 40.3766 52.5704 39.6839 52.0641 39.1672C51.5578 38.6504 50.8711 38.3497 50.148 38.328ZM28 0.5C20.8219 0.520474 13.9258 3.29696 8.736 8.256V3.3C8.736 2.55739 8.441 1.8452 7.9159 1.3201C7.3908 0.794999 6.67861 0.5 5.936 0.5C5.19339 0.5 4.4812 0.794999 3.9561 1.3201C3.431 1.8452 3.136 2.55739 3.136 3.3V15.9C3.136 16.6426 3.431 17.3548 3.9561 17.8799C4.4812 18.405 5.19339 18.7 5.936 18.7H18.536C19.2786 18.7 19.9908 18.405 20.5159 17.8799C21.041 17.3548 21.336 16.6426 21.336 15.9C21.336 15.1574 21.041 14.4452 20.5159 13.9201C19.9908 13.395 19.2786 13.1 18.536 13.1H11.816C14.9029 9.87404 18.8835 7.6442 23.2467 6.6967C27.61 5.74921 32.1569 6.12729 36.3037 7.78242C40.4506 9.43754 44.0082 12.2942 46.5199 15.9857C49.0316 19.6772 50.3828 24.0351 50.4 28.5C50.4 29.2426 50.695 29.9548 51.2201 30.4799C51.7452 31.005 52.4574 31.3 53.2 31.3C53.9426 31.3 54.6548 31.005 55.1799 30.4799C55.705 29.9548 56 29.2426 56 28.5C56 24.823 55.2758 21.182 53.8686 17.7849C52.4615 14.3877 50.399 11.3011 47.799 8.70101C45.199 6.10097 42.1123 4.03851 38.7151 2.63137C35.318 1.22424 31.677 0.5 28 0.5Z",
            fill: color
        })
    }));
};
